import { useSearchParams } from "react-router-dom";
import { Wrapper, PageBtn, Ellipsis } from "./styles/Pagination.styles";

export const ITEMS_PER_PAGE = 9;

function getPages(current, total) {
  const pages = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (current > 3) pages.push("...");
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);
  if (current < total - 2) pages.push("...");
  pages.push(total);
  return pages;
}

function Pagination({ totalItems, totalPages: totalPagesProp, pageSize, scrollTargetRef }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const totalPages =
    totalPagesProp ?? Math.ceil(totalItems / (pageSize || ITEMS_PER_PAGE));

  if (totalPages <= 1) return null;

  const goTo = (page) => {
    const newParams = new URLSearchParams(searchParams);
    if (page === 1) {
      newParams.delete("page");
    } else {
      newParams.set("page", page);
    }
    setSearchParams(newParams);

    if (scrollTargetRef?.current) {
      scrollTargetRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const pages = getPages(currentPage, totalPages);

  return (
    <Wrapper>
      <PageBtn
        onClick={() => goTo(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="Previous page"
      >
        &lsaquo;
      </PageBtn>
      {pages.map((p, i) =>
        p === "..." ? (
          <Ellipsis key={`e${i}`}>&hellip;</Ellipsis>
        ) : (
          <PageBtn key={p} $active={p === currentPage} onClick={() => goTo(p)}>
            {p}
          </PageBtn>
        ),
      )}
      <PageBtn
        onClick={() => goTo(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="Next page"
      >
        &rsaquo;
      </PageBtn>
    </Wrapper>
  );
}

export default Pagination;
